import React from 'react';
import DiscourseNavigation from './DiscourseNavigation';
import InfiniteScroll from 'react-infinite-scroll-component';
import ListOfDiscourse from './ListOfDiscourse';

import {
  usePublishedDiscourseState,
  usePublishedDiscourseActions
} from './PublishedDiscourseContext';
import PublishedDiscourseLoader from './PublishedDiscourseLoader';
import { usePublishedDiscourseCapabilities } from './usePublishedDiscourseCapabilities';
import { useCapabilities } from '../../Shared/capabilities';

import { getPublishedDocuments } from './restApi';

import styles from './DiscourseIndex.module.scss';

const PublishedDiscourseContent = ({ authenticatedUser }) => {
  usePublishedDiscourseCapabilities(authenticatedUser);
  const capabilities = useCapabilities();
  const state = usePublishedDiscourseState();
  const { onResponse, onError } = usePublishedDiscourseActions();

  const loadMoreDocuments = () => {
    const nextPageNumber = (state.pageNumber || 1) + 1;
    getPublishedDocuments({
      pageNumber: nextPageNumber,
      onResponse,
      onError,
    });
  };

  return (
    <>
      <section className={styles.pageSection}>
        <DiscourseNavigation
          viewStateOptions={[]}
        />
      </section>
      <InfiniteScroll
        dataLength={(state.documents || []).length}
        next={loadMoreDocuments}
        hasMore={state.moreDocumentsAvailable ?? true}
        loader={
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        }
        endMessage={
          <p style={{ textAlign: 'center' }}>
            <b>You've seen all published discourse</b>
          </p>
        }
        scrollableTarget="html"
      >
        <ListOfDiscourse discourse={state.documents || []} />
      </InfiniteScroll>
    </>
  );
};

const PublishedDiscourse = ({ authenticatedUser }) => {
  return (
    <>
      <PublishedDiscourseLoader />
      <PublishedDiscourseContent authenticatedUser={authenticatedUser} />
    </>
  );
};

export default PublishedDiscourse;
